import { swap } from "utils/object";

export const signagePostedValues = {
  Posted: true,
  "Not posted": false,
};

export const signagePostedTexts = swap(signagePostedValues);
